import akasa1 from "./1-2-1.png";
import akasa2 from "./3-2-1.png";
import akasa3 from "./4.png";
import akasa4 from "./5-2.png";

const Akasa = [akasa1, akasa2, akasa3, akasa4];

export default Akasa;
